import React from "react";
import * as S from "./styles";

interface IBoxProps extends React.HTMLAttributes<HTMLDivElement> {
	title?: string;
	showBox?: boolean;
	children: React.ReactNode;
	id?: string;
}

function Box({ title, children, id, ...props }: IBoxProps) {
	const generatedId = id ? `${id}` : "id-general-box";
	return (
		<S.Container {...props} id={generatedId}>
			{title && <S.Title>{title}</S.Title>}
			{children}
		</S.Container>
	);
}

export default Box;
